import { Component } from '@angular/core';
import { SharingDataService } from 'src/sharing-data.service';
import { Address }  from './address.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.css']
})
export class AddressComponent 
{

   ngAfterViewInit() {
    // This executes right after the HTML hits the screen
    setTimeout(() => {
      // Fake a window resize event to force the browser to snap the header and banner together
      window.dispatchEvent(new Event('resize'));
    }, 50); // A 50ms delay is invisible to the user but enough for the browser
  }

    constructor(private sharingDataService : SharingDataService,private router: Router) {}

    ngOnInit(){
      this.getCustomerId();
    }

  address = {
      name: '',
      contact: '',
      address: '',
      city: '',
      state: '',
      pincode: '',
      landmark:'',
      country:'India',
      street:'',
      email:'',
      address_type: 'Home',
      CustomerId:0
    };

  addressDetails:any;
  addressId:number=0;
  addressDetailsByAddressId:any;
  addressDetailsByCustomerId:any;
  customerId:number=0;
  submitForm() {
    console.log('Address saved:', this.address);
    
    // You can send this to your backend or store locally
     this.customerId= Number(localStorage.getItem('customerId'));
    this.address.CustomerId=this.customerId
    console.log('this.address.customerId',this.customerId);
    this.sharingDataService.addAddress(this.address).subscribe({
      
      next:(response) =>{
        console.log('Address json', this.address);
         console.log('Address added:',response);
          this.addressDetails=response;
        alert('Address saved successfully!');
          this.router.navigate(['/viewCart']);

      }
    })
  }

    getCustomerId(){
     this.sharingDataService.loggedInCustomerIdVal.subscribe(val => {
    console.log('Received in Address Component B:', val);
    this.customerId=val
    if((this.customerId!=null || this.customerId!=undefined) &&(this.addressId!=null || this.addressId!=undefined)){
        this.getAddressByCustomerId();
    }
    
      
  });
  }

  getAddressByAddressId(){
     this.sharingDataService.getAddressByAddressId(this.addressId).subscribe({
      next:(response) =>{
         console.log('Address Details',response);
          this.addressDetailsByAddressId=response;

      }
    })
  }

   getAddressByCustomerId(){
     this.sharingDataService.getAddressByCustomerId(this.customerId).subscribe({
      next:(response) =>{
         console.log('Address Details',response);
          this.addressDetailsByCustomerId=response;

      }
    })
  }

  deleteAddressByAddressId(){
    this.sharingDataService.deleteAddressByAddressId(this.addressId).subscribe({
      next:(response) =>{
         console.log('Address deleted',response);
         
          this.getAddressByCustomerId();
      }
    })
  }
}
